import en from "@kovernow/flows/locales/en.json";

/**
 * Plain error page when config is missing/invalid or the host doesn't match
 * (CAP-1). React is not mounted; strings still come from the locale file.
 */
export function renderFatal(root: HTMLElement, reason: string): void {
  document.title = en.bootstrap.configErrorTitle;
  root.replaceChildren();
  const main = document.createElement("main");
  main.style.cssText = "max-width:40rem;margin:4rem auto;padding:0 1rem;font-family:system-ui,sans-serif;line-height:1.5";
  const h1 = document.createElement("h1");
  h1.textContent = en.bootstrap.configErrorTitle;
  h1.tabIndex = -1;
  const p = document.createElement("p");
  p.textContent = en.bootstrap.configErrorBody.replace("{{reason}}", reason);
  main.append(h1, p);
  root.append(main);
  h1.focus();
}
